<template>
    <div id="modal-enter-detail-menu" class="modal fade show">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item border-0" @click="openPrivateInfo">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-user icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2"> 個人情報 </span>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item border-0" @click="openResume">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-external-link-alt icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2"> 履歴書 </span>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item border-0" @click="openContractPeriod">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-clipboard icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2"> 契約期間 </span>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item border-0" @click="openExitConfirm">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-door-closed icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2"> 退場確定 </span>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item border-0" @click="changeToExited">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-house-user icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">
                                        退場済みに変更 
                                    </span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from 'js/event-bus'
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                item: {}
            }
        },
        mounted () {
            this.menuBusOn()
        },
        methods: {
            menuBusOn () {
                EventBus.$on('workStatusMenu', (item) => {
                    this.item = item
                    this.openThis()
                })
            },
            openThis () {
                $('#modal-enter-detail-menu').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-enter-detail-menu').modal('hide')
            },
            resetThis () {
                this.item = {}
            },
            openPrivateInfo () {
                this.$parent.openPrivateInfo(this.item.user_id)
                this.hideThis()
            },
            openResume () {
                window.open(this.item.resume, "_blank")
                this.hideThis()
            },
            openContractPeriod () {
                this.$parent.openContractPeriod(this.item)
                this.hideThis()
            },
            openExitConfirm () {
                this.$parent.openExitConfirm(this.item)
                this.hideThis()
            },
            changeToExited () {
                let lev = 2
                let msg = "退場済みに更新しますか？"
                let msgKey = "changeToExited"
                this.$parent.openMsg(lev, msg, msgKey, this.item)
                this.hideThis()
            },
            cancelEnter () {
                this.$parent.cancelEnter(this.item)
                this.hideThis()
            }
        }
    }
</script>

<style>

</style>
